import {Drawer} from 'antd';
import {FormDrawer} from './Components/FormDrawer';
import {ModalProps} from 'antd/es';

export interface ProDrawerProps extends ModalProps {
    onOk?(): void;
    onClose?(): void;
    footer?: any;
}

export const ProDrawer = Object.assign(Drawer, {
    Form: FormDrawer,
});
